import * as React from 'react';
import MainSectionLayout from '../layout/MainSectionLayout';
import { TLCode } from '../../common/enums';
import { RouteComponentProps } from 'react-router';

interface ErrorPageProps extends RouteComponentProps<{ errorMessage: string }> {}

export default class ErrorPage extends React.Component<ErrorPageProps> {
  public render() {
    const { errorMessage } = this.props.match.params;
    return (
      <MainSectionLayout title={TLCode.ERROR_PAGE_Title}>
        <div>{errorMessage}</div>
      </MainSectionLayout>
    );
  }
}
